import { __assign } from "tslib";
import React, { Suspense } from 'react';
import Skeletons from '../../infoui-components/components/Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootstrapInfoTable = React.lazy(function () {
    return import('../../bootstrap-components/components/BTBootstrapTable');
});
var infoBootstrapTable = function (props) {
    return (React.createElement(BootstrapInfoTable, __assign({}, props)));
};
export var InfoBootstrapTable = function (props) {
    var componentToDisplay = infoBootstrapTable(props);
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
export default InfoBootstrapTable;
//# sourceMappingURL=BootstrapTable.js.map